import MaterialCommunityIcons from '@expo/vector-icons/MaterialCommunityIcons';
import { Button, Colors } from '@gripp/shared-ui';
import { StyleSheet } from 'react-native';
import { ModalButton } from '../../shared/components/modalButton';
import { EditWorkspaceForm } from './editWorkspaceForm';

type EditWorkspaceMenuProps = {
  label: string;
  workspaceId: string;
};

export const EditWorkspaceMenu = (props: EditWorkspaceMenuProps) => {
  return (
    <ModalButton
      label=""
      omitPadding={true}
      customButton={(toggleVisibility) => (
        <Button
          variant="rounded"
          size="default"
          state="default"
          leftIcon={
            <MaterialCommunityIcons
              name="pencil-outline"
              color={Colors.blackText}
              size={16}
            />
          }
          onPress={() => toggleVisibility(true)}
        >
          {props.label}
        </Button>
      )}
      modalComponent={({ onComplete }) => {
        return (
          <EditWorkspaceForm
            onComplete={onComplete}
            workspaceId={props.workspaceId}
          />
        );
      }}
      containerStyle={styles.modalContainer}
    />
  );
};

const styles = StyleSheet.create({
  modalContainer: {
    alignSelf: 'center',
    backgroundColor: Colors.primaryGrayBackground,
    borderRadius: 10,
    width: 560,
    height: 218,
  },
});
